import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from './icon-registry';

library.add( ...Object.values( icons ) );
